
/* eslint-disable max-len */
const StartFinish = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20,20c-1.1,0-2-.9-2-2v-7.17l-2.83-2.83h-6.34l-2.83,2.83v7.17c0,1.1-.9,2-2,2s-2-.9-2-2v-8c0-.53.21-1.04.59-1.41l4-4c.38-.38.88-.59,1.41-.59h8c.53,0,1.04.21,1.41.59l4,4c.38.38.59.88.59,1.41v8c0,1.1-.9,2-2,2Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default StartFinish;
